// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import InputBlurChange from "metabase/components/InputBlurChange";

export const NumericInputBlurChange = styled(InputBlurChange)`
  width: auto;
`;
